// initial state
const state = {
  image: '',
  fileName: '',
}

const getters = {
}

const actions = {
}

const mutations = {
  setImage (state, image) {
    state.image = image
  },
  setFilename (state, fileName) {
    state.fileName = fileName
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
